export default "__VITE_ASSET__D1qDsA69__"